/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-vars */
import {
  get as getAxios,
  post as postAxios,
  put as putAxios,
  deleteCall as deleteAxios,
} from "../apiHandler";

const endPoint = process.env.REACT_APP_API_BASE_URL;
const PAGE_SIZE = 10;

// const accessTokenFromLocal = "0fc0515a-d081-4b4a-83ab-7c104c2e1357";

const get = (url, { data, accessToken }) =>
  getAxios(url, { data, accessToken, endPoint });
const post = (url, { accessToken, data, params }) =>
  postAxios(url, { accessToken, data, endPoint, params });
const put = (url, { accessToken, data, params }) =>
  putAxios(url, { accessToken, data, endPoint, params });
const deleteCall = (url, { accessToken, data, params }) =>
  deleteAxios(url, { accessToken, data, endPoint, params });

export default class University {
  static updateUniversity({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = put(`/api/university`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    University.updateUniversity.cancel = request.cancel;
    return request;
  }

  static createUniversity({ data }) {
    const accessTokenFromLocal = localStorage.getItem("authToken");
    const request = post(`/api/university`, {
      accessToken: accessTokenFromLocal,
      data,
    });

    University.createUniversity.cancel = request.cancel;
    return request;
  }
}
